<template>
    <dropdown
        v-bind="$attrs"
        :is-dropdown-open="isDropdownOpen"
        @hide="hide"
        @trigger-clicked="$emit('trigger-clicked')"
        @dropdown-entered="$emit('dropdown-entered', $event)"
    >
        <template #trigger="props">
            <slot
                name="trigger"
                v-bind="props"
            />
        </template>
        <template #trigger-contents>
            <slot name="trigger-contents" />
        </template>
        <template #content>
            <slot name="content">
                <dropdown-list
                    :items="items"
                    :selection="selection"
                    v-bind="ulProperties"
                    @list-item-clicked="onListItemClick"
                >
                    <template
                        v-for="item in items"
                        #[item.key]
                    >
                        <slot :name="item.key" />
                    </template>
                </dropdown-list>
            </slot>
        </template>
    </dropdown>
</template>

<script>
import DropdownList from './dropdown-list.vue';
import Dropdown from './base-dropdown.vue';
import { hovered } from '../directives/hovered.js';
import { innerFocus } from '../directives/inner_focus.js';


/**
 * List Dropdown
 * A dropdown component that takes a prop to tell it when it is open or not.
 * By default, shows the cta button as the trigger.
 * Can take in a list of items { key, value, icon } and displays a list of buttons in the dropdown.
 * Helpful when the state of the dropdown needs to be modified externally.
 */
export default {
    props: {
        isDropdownOpen: {
            type: Boolean,
            required: true,
        },
        /**
         * Array of items to be displayed in the list dropdown. Has the format of { key, value, icon }
         */
        items: {
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Properties object applied to the ul element of the list dropdown
         */
        ulProperties: {
            type: Object,
            default: () => ({}),
        },
        selection: {
            default: null,
        },
    },

    methods: {
        hide() {
            this.$emit('hide');
        },
        onListItemClick(item) {
            // Usually when we click on dropdown item, it closes the dropdown
            // But there are some exceptions:
            // 1) When "item.keepOpenAfterClick" is "true"
            // 2) When "item.component" doesn't dispatch "click" event
            // 3) When item customize appearance with slot (slot with "item.key" as name)
            if (!item.keepOpenAfterClick) {
                this.hide();
            }

            this.$nextTick().then(() => {
                this.$emit('list-item-clicked', item);
            });
        },
    },

    directives: {
        hovered,
        innerFocus,
    },

    components: {
        Dropdown,
        DropdownList,
    },
};
</script>
